module.exports = __webpack_public_path__ + "static/media/table.1040818b.png";